<template>
  <b-dropdown
    variant="link"
    toggle-class="text-decoration-none nav-link"
    menu-class="w-100"
  >
    <template
      #button-content
      class="nav-link"
    >
      {{ current_language.code }}
    </template>

    <template v-for="(item, key) in available_languages">
      <b-dropdown-item
        :key="key"
        :title="item.label"
        @click="changeLang(item.code)"
      >
        {{ item.code }}
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LanguageSelector",
  created() {
    if (this.available_languages === null) {
      this.$store.dispatch("layout/getInitInfos");
    }
  },
  methods: {
    changeLang(lang) {
      this.$store.dispatch("layout/setCurrentLanguage", lang);
    },
  },
  computed: {
    ...mapState({
      current_language: (state) => state.layout.current_language,
      available_languages: (state) => state.layout.available_languages,
    }),
  },
};
</script>
